export const GATES = {
  ASK_WHY_AUTOMATION: 'ask_why_automation',
  COMPLETE_A_SURVEY_ACTION: 'complete_a_survey_action',
  COPY_A_SURVEY: 'copy_a_survey',
  CREATE_SURVEY_PEOPLE_GROUPS: 'create_survey_people_groups',
  DOWNLOAD_SURVEY_AS_DOCX: 'download_survey_as_docx',
  GEN_REP_SAMPLE: 'gen_rep_sample',
  INSTANT_SURVEY_AUTO_SAVE: 'auto_save_survey',
  INSTANT_SURVEY_MAINTENANCE: 'instant_survey_maintenance',
  MAXDIFF_PREFERENCE_ANALYSIS: 'maxdiff_preference_analysis',
  MULTIPLE_SUBSCRIPTIONS_REVAMP: 'multiple_subscriptions_revamp',
  NEW_ITEM_SURVEYS: 'new_item_surveys',
  PIPING_RESPONSES: 'piping_responses',
  PREVIEW_SURVEY: 'preview_survey',
  QUESTION_LIBRARY: 'question_library',
  QUESTION_TYPE_CONT_SUM: 'question_type_contsum',
  QUESTION_TYPE_MAX_DIFF: 'question_type_maxdiff',
  QUESTION_TYPE_NUMERIC: 'question_type_numeric',
  QUESTION_TYPE_VIDEO: 'video_survey',
  RESEARCH_OBJECTIVES: 'research_objectives',
  SORT_CHARTS: 'sort_charts',
  STANDARD_SURVEY: 'standard_survey',
  SURVEY_DASHBOARD_FULL_WIDTH: 'survey_dashboard_full_width',
  SURVEY_TEMPLATES: 'survey_templates',
  TOP_2_BOX: 'top_2_box',
  WHOLE_SURVEY_SUMMARY: 'ai_overall_summary',
};
